// extracted by mini-css-extract-plugin
export default {"city":"MQsg_jFwLGNO3W7WnRBr","warning_button":"sTA4G4_3M43kzIs5LhTN"};